import {languages} from '../language/languages'
import {Fragment, useContext} from "react";
import {LanguageContext} from "../App";

import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, SelectorIcon } from '@heroicons/react/solid'
import {useLocation, useNavigate} from "react-router-dom";

const abr = {
    en: "EN",
    ru: "RU"
}

const LocaleSwitch = () => {
    const {language, toggler} = useContext(LanguageContext)

    const location = useLocation()
    const navigate = useNavigate()
    // console.log('location', location.pathname.split('/') )
    // console.log("test",location.pathname.split('/').slice(2).join('/'))

    const handleChange = (value) => {
        toggler(value)
        let lang = location.pathname.split('/')[1];
        if (value==='en'){
            if (lang.length > 2){
                navigate('/en'+location.pathname)
            }
            if (lang.length === 0){
                navigate('/en')
            }
        }
        if (value==='ru'){
            if (lang === 'en'){
                let path = location.pathname.split('/').slice(2).join('/')
                console.log('path: '+path)
                console.log(path.length)
                if (path.length === 0) {
                    navigate('/')
                } else {
                    navigate('/'+location.pathname.split('/').slice(2).join('/'))
                }

            }
        }


    }



    return (
        <div>
            <div className="">
                <Listbox value={language.name} onChange={handleChange}>
                    <div className="relative mr-2">
                        <Listbox.Button className="text-sm border relative w-full py-1 pl-2 pr-10 text-left bg-white rounded-md cursor-default">
                            <span className="block truncate">{abr[language.name]}</span>
                            <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                               <SelectorIcon
                                   className="w-5 h-5 text-gray-400"
                                   aria-hidden="true"
                               />
                            </span>
                        </Listbox.Button>
                        <Transition
                            as={Fragment}
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Listbox.Options className="absolute right-0 border z-20 py-1 mt-1 overflow-auto text-sm bg-white rounded-md shadow-md max-h-60">
                                {languages.list.map((lang, index) => (
                                    <Listbox.Option
                                        key={lang.alias}
                                        className={({ active }) =>
                                            `cursor-default select-none relative py-2 pl-10 pr-4 ${
                                                active ? 'text-black bg-gray-100' : 'text-gray-900'
                                            }`
                                        }
                                        value={lang.alias}
                                    >
                                        {({ selected }) => (
                                            <>
                                                <span className={`block truncate ${selected ? 'font-medium' : 'font-normal'}`}>
                                                    {lang.title}
                                                </span>
                                                { selected ? (
                                                    <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-red-600">
                                                       <CheckIcon className="w-5 h-5" aria-hidden="true" />
                                                    </span>
                                                ) : null}
                                            </>
                                        )}
                                    </Listbox.Option>
                                ))}
                            </Listbox.Options>
                        </Transition>
                    </div>
                </Listbox>
            </div>


        </div>
    )
}

export default LocaleSwitch